import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Brand and description */}
        <div className="footer-brand">
          <h3>M.T.8848 Pizza</h3>
          <p>Fresh pizza made daily in Darwin, NT. Named after Mount Everest at 8,848 metres — standing tall in taste and quality.</p>
        </div>

        {/* Quick links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/menu">Menu</Link></li>
            <li><Link to="/build">Build Your Own</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact info */}
        <div className="footer-contact">
          <h4>Contact Us</h4>
          <p>Phone: <a href="tel:0400123456">0400 123 456</a></p>
          <p>Email: m.t.8848pizza@gmail.com</p>
          <p>Location: Darwin, NT</p>
          <p>Hours: 11am - 9pm, 7 days a week</p>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>&copy; {year} M.T.8848 Pizza. All rights reserved.</p>
        <p>Built by Group 9 — HIT226 CDU Darwin</p>
      </div>
    </footer>
  );
}

export default Footer;